import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=6140141a"
import script from "./EmptyState.vue?vue&type=script&lang=js"
export * from "./EmptyState.vue?vue&type=script&lang=js"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=6140141a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports